import { Injectable } from '@angular/core';
import { ROOT_SCOPE_VARIABLES } from '@core/settings/root-scope.settings';
import { Subject } from 'rxjs';
import { PanelsService } from './panels.service';
import { RootScopeService } from './upgraded-providers/wrappers/root-scope.service';

@Injectable()
export class OrdersService {
  private _newOrderCreated$ = new Subject<any>();
  orderCreated$ = this._newOrderCreated$.asObservable();

  constructor(
    private _panelsService: PanelsService,
    private _rootScopeService: RootScopeService,
  ) {
    this._rootScopeService.detectScopeChanges(ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER);
    this._rootScopeService.detectScopeChanges(ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER_PANEL_CLOSE);

    this._rootScopeService.rootScopeObservable
      .subscribe(rootScope => {
        if (rootScope[ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER]) {
          this._newOrderCreated$.next({});
          this.closeOrderPanel();
        }

        if (rootScope[ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER_PANEL_CLOSE]) {
          this.closeOrderPanel()
        }
      });
  }

  openNewOrderPanel(): void {
    this._rootScopeService.updateScope(ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER_PANEL, {});
    this._panelsService.openOrderPanel();
  }

  openOrderDetailsPanel(orderData: any): void {
    this._rootScopeService.updateScope(ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER_PANEL_DETAILS, orderData);
    this._panelsService.openOrderPanel();
  }

  unsubscribeFromScopeChanges(){
    this._rootScopeService.unsubscribeFromScopeChanges([ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER, ROOT_SCOPE_VARIABLES.ORDER.NEW_ORDER_PANEL_CLOSE]);
  }

  private closeOrderPanel(): void {
    this._panelsService.closeOrderPanel();
  }
}
